import { z } from "zod";

const email = z.string().trim().toLowerCase().email().max(200).refine(value => !/[\r\n]/.test(value), "Enter one email address");
export const contactDeliverySchema = z.object({
  enabled: z.boolean().default(true),
  to: z.union([z.literal(""), email]).default(""),
  cc: z.array(email).max(3).default([])
}).strict().superRefine((value, context) => {
  const addresses = [value.to, ...value.cc].filter(Boolean);
  if (new Set(addresses).size !== addresses.length) context.addIssue({ code: "custom", path: ["cc"], message: "Use different email addresses for the recipient and each CC" });
});
